module.exports = new Promise((resolve) => {
                    const src = 'https://kin-analytics-kepler.web.app/remoteEntry.js';
                    const el = document.createElement('script');
                    el.src = src;
                    el.onload = () => resolve(window.KeplerAppMicro);
                    el.onerror = () => { console.warn('[MFE] KeplerAppMicro failed to load'); resolve({ get: () => Promise.resolve(() => () => null), init: () => {} }); };
                    document.head.appendChild(el);
                });